/* globals Swiper */
import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import { sliderPagination } from '~/js/helpers';

const logoSliderSections = [...document.querySelectorAll('.overview-logo')];

logoSliderSections.forEach((logoSliderSection) => {
	const logoSlider = logoSliderSection.querySelector('.swiper-logos');

	if (!logoSlider) {
		return;
	}

	const swiper = new Swiper(logoSlider, {
		modules: [Navigation, Pagination, A11y, Mousewheel],
		a11y: true,
		grabCursor: true,
		loop: true,
		slidesPerView: 2,
		spaceBetween: 16,
		keyboard: {
			enabled: true,
		},
		navigation: {
			nextEl: logoSlider.querySelector('.swiper-button-next'),
			prevEl: logoSlider.querySelector('.swiper-button-prev'),
		},
		pagination: sliderPagination(logoSlider.querySelector('.swiper-pagination')),
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		breakpoints: {
			760: {
				slidesPerView: 4,
				spaceBetween: 32,
			},
			1024: {
				slidesPerView: 6,
			},
		},
	});
});
